<div mat-dialog-content>
    <div
    class="
      col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
      row
    "
  >
  
    <div
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      <div
        class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
        "
      >
        <a
          href="..//..//..//..//assets/exampleItems.xlsx"
          target="_blank"
          rel="noopener noreferrer"
          >Download excel format</a
        >
      </div>
      <div
        class="
          center
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
        "
        style="margin-top: 6vh"
      >
        <ngx-file-drop
          dropZoneLabel="Drop files here"
          (onFileDrop)="dropped2($event)"
          (onFileOver)="fileOver2($event)"
          (onFileLeave)="fileLeave2($event)"
        >
          <ng-template
            ngx-file-drop-content-tmp
            let-openFileSelector="openFileSelector"
          >
            <div
              class="
                col-xs-12
                col-sm-12
                col-md-12
                col-lg-12
                col-xl-12
                col-xxl-12
                row
              "
            >
              <button
                type="button"
                (click)="openFileSelector()"
                mat-raised-button
                color="primary"
                class="
                  col-xs-12
                  col-sm-12
                  col-md-12
                  col-lg-12
                  col-xl-12
                  col-xxl-12
                "
              >
                Browse Files
              </button>

              <P
                style="text-align: center; top: 2vh"
                class="
                  col-xs-12
                  col-sm-12
                  col-md-12
                  col-lg-12
                  col-xl-12
                  col-xxl-12
                "
              >
                Upload Document</P
              >
            </div>
          </ng-template>
        </ngx-file-drop>
      </div>
      <div
        class="
          upload-table
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
        "
        style="margin-top: 6vh"
      >
        <table class="table table-dark table-striped">
          <thead>
            <tr>
              <th>Row</th>
              <th>item number</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody *ngIf="viewRegistrosMasivos" class="upload-name-style">
            <tr
              *ngFor="let item of arrayMensajesMasivoExcel; let i = index"
            >
              <td>
                <strong>{{ item.celda }}</strong>
              </td>
              <td>
                <strong>{{ item.itemname }}</strong>
              </td>
              <td>
                <strong>{{ item.mensajes }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">close</button>
 
</div>
